import { CaretUpDownIcon } from '@phosphor-icons/react';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns/format';

import { Button } from '@/components/ui/button';
import { GenericTable, TableItemStatus } from '@/modules/common/components';

import { Event } from '../types';

interface EventsTableProps {
  data: Event[];
  onClick: (item: Event) => void;
}

const columns: ColumnDef<Event>[] = [
  {
    size: 300,
    accessorKey: 'name',
    header: ({ column }) => {
      return (
        <Button
          variant="transparent"
          className="p-0 uppercase text-sm font-bold"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          <CaretUpDownIcon />
        </Button>
      );
    },
    cell: ({ row }) => row.getValue('name'),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 200,
    cell: ({ row }) => <TableItemStatus status={row.getValue('status')} />,
  },
  {
    accessorKey: 'aiModel',
    header: 'AI Model',
    cell: ({ row }) => row.getValue('aiModel'),
  },
  {
    size: 200,
    accessorKey: 'startDate',
    header: ({ column }) => {
      return (
        <Button
          variant="transparent"
          className="p-0 uppercase text-sm font-bold"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Start date
          <CaretUpDownIcon />
        </Button>
      );
    },
    cell: ({ row }) =>
      format(new Date(row.getValue('startDate')), 'yyyy-MM-dd'),
  },
];

export function EventsTable({ data, onClick }: EventsTableProps) {
  return (
    <GenericTable
      data={data}
      onClick={onClick}
      columns={columns}
      searchable
      searchColumns={['name']}
      searchPlaceholder="Search by event name"
      emptyDescription="No event added yet"
    />
  );
}
